import React, { useState } from 'react';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    location: '',
    email: '',
    message: ''
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Name is required';
    if (!form.mobile.trim()) newErrors.mobile = 'Mobile number is required';
    else if (!/^\d{10}$/.test(form.mobile.trim())) newErrors.mobile = 'Enter a valid 10-digit mobile number';
    if (!form.location.trim()) newErrors.location = 'Location is required';
    if (!form.email.trim()) newErrors.email = 'Email is required';
    else if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) newErrors.email = 'Enter a valid email address';
    if (!form.message.trim()) newErrors.message = 'Message is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        const response = await fetch('http://myastrolabs.com/save_contact.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(form).toString()
        });
        const result = await response.text();
        if (result === 'Success') {
          alert('Enquiry submitted!');
          setForm({ name: '', mobile: '', location: '', email: '', message: '' });
          setErrors({});
        } else {
          alert('Submission failed!');
        }
      } catch (err) {
        console.error('Error:', err);
        alert('Error submitting form!');
      }
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-info">
        <p style={{ marginBottom: '10px' }}>Call us or fill the form below and we will get back to you!</p>
        <h2 style={{ marginBottom: '20px' }}>Acharya Senthilkumar</h2>
        <div style={{ marginBottom: '18px' }}>
          <i className="fas fa-map-marker-alt" style={{ color: '#ffd600', marginRight: '8px' }}></i>
          FG-002, Featherlite Swargam Apartment,<br />
          Jeyaram Nagar 2nd Street,<br />
          Guduvancheri,<br />
          Chengalpet Dt.- 603202. Tamil Nadu, India.
        </div>
        <div style={{ marginBottom: '18px' }}>
          <i className="fas fa-phone" style={{ color: '#ffd600', marginRight: '8px' }}></i>
          +91 7200044010<br />
          {/* <span style={{ fontWeight: 'bold' }}>(Tuesday is a weekly holiday for us.<br />Please do not make phone calls on Tuesdays.)</span> */}
        </div>
        <div style={{ marginBottom: '18px' }}>
          <i className="fas fa-envelope" style={{ color: '#ffd600', marginRight: '8px' }}></i>
          myastrolabs@gmail.com
        </div>
        <div style={{ marginTop: '24px', fontSize: '2rem' }}>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffffff', marginRight: '18px' }}><i className="fab fa-facebook"></i></a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: '#f9f9f9ff', marginRight: '18px' }}><i className="fab fa-youtube"></i></a>
          <a href="https://wa.me/917200044010" target="_blank" rel="noopener noreferrer" style={{ color: '#fbfbfbff' }}><i className="fab fa-whatsapp"></i></a>
        </div>
      </div>
      <div className="contact-form-section">
        <h3 style={{ fontStyle:'italic',color:"white", marginBottom: '18px' }}>Tell Us What’s on Your Mind</h3>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <div style={{ flex: 1 }}>
              <input
                type="text"
                name="name"
                placeholder="Your Name *"
                value={form.name}
                onChange={handleChange}
                className="form-control"
              />
              {errors.name && <div style={{ color: 'red', fontSize: '0.95rem', marginTop: '4px' }}>{errors.name}</div>}
            </div>
            <div style={{ flex: 1 }}>
              <input
                type="email"
                name="email"
                placeholder="Your Email *"
                value={form.email}
                onChange={handleChange}
                className="form-control"
              />
              {errors.email && <div style={{ color: 'red', fontSize: '0.95rem', marginTop: '4px' }}>{errors.email}</div>}
            </div>
          </div>
          <div className="form-row">
            <div style={{ flex: 1 }}>
              <input
                type="text"
                name="mobile"
                placeholder="Phone Number *"
                value={form.mobile}
                onChange={handleChange}
                className="form-control"
              />
              {errors.mobile && <div style={{ color: 'red', fontSize: '0.95rem', marginTop: '4px' }}>{errors.mobile}</div>}
            </div>
            <div style={{ flex: 1 }}>
              <input
                type="text"
                name="location"
                placeholder="City"
                value={form.location}
                onChange={handleChange}
                className="form-control"
              />
              {errors.location && <div style={{ color: 'red', fontSize: '0.95rem', marginTop: '4px' }}>{errors.location}</div>}
            </div>
          </div>
          <div>
            <textarea
              name="message"
              placeholder="Your Message *"
              value={form.message}
              onChange={handleChange}
              rows={3}
              className="form-control"
              style={{ marginBottom: '12px' }}
            />
            {errors.message && <div style={{ color: 'red', fontSize: '0.95rem', marginTop: '4px' }}>{errors.message}</div>}
          </div>
          <button type="submit" className="send-btn">Send Message</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
